import styled from 'styled-components';

export const PopupBox = styled.div`
  border-radius: 10px;
  background: rgb(39, 47, 60);
  margin: 5px;
  padding: 10px;
`

export const PopupHandle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: move;

  & > div {
    flex: 9;
    text-align: center;
    font-size: 20px;
  }

  & > svg {
    cursor: pointer;
    margin-right: 5px;
    width: 30px;
    height: 30px;
  }
`